export default __webpack_public_path__ + "static/media/button__close-white.f5ec523c.svg";